import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
    selector: 'app-player-ranking-list-entry',
  imports: [MatIconModule, MatCardModule],
    templateUrl: './player-ranking-list-entry.component.html',
    styleUrls: ['./player-ranking-list-entry.component.css']
})
export class PlayerRankingListEntryComponent implements OnInit {

  @Input() List: any;
  constructor(private router: Router) { }

  ngOnInit() {
  }

  openRankingList(): void {
    if (!this.List?.ListId) {
      return;
    }

    this.router.navigate(['/lists/details', this.List.ListId]);
  }

}
